import GameData from "../GameData";
import {CargoWeight, LOCO_CARGO_LIFTING_CAPACITY, LOCO_WEIGHT} from "../Balance";

class Train {
    constructor(id, parentStationID, locomotives, carTrainPacks,  trainType, locoType) {
        this.id = id;
        this.trainType = trainType;
        this.locoType = locoType;
        this.parentStationID = parentStationID;
        this.locomotives = locomotives;
        this.carTrainPacks = carTrainPacks;
    }
    getWeight(){
        let weight = 0;
        for (let  i = 0; i < this.locomotives.length; i++){
            let loco = GameData.CurrentGame.getLocoById(this.locomotives[i]);
            weight += LOCO_WEIGHT[loco.type];
        }
        for (let  i = 0; i < this.carTrainPacks.length; i++){
            let trainCarPack = GameData.CurrentGame.getTrainCarById(this.carTrainPacks[i]);
            weight += (CargoWeight(trainCarPack.type)) * trainCarPack.trainCarCount;
        }
        return weight;
    }
    getCargoCapacity(){
        return this.locomotives.filter( x=> GameData.CurrentGame.getLocoById(x).isHot).length *  LOCO_CARGO_LIFTING_CAPACITY[this.locoType];
    }
    getTrainCarWeight(gameData = GameData.CurrentGame){
        let weight = 0;
        for (let  i = 0; i < this.carTrainPacks.length; i++){
            let pack = gameData.getTrainCarById(this.carTrainPacks[i]);
            weight += pack.trainCarCount;
        }
        return weight;
    }
    getActiveLocoType(){
        for (let i = 0; i < this.locomotives.length; i++){
            if(this.locomotives[i].hasBrigade){
                return this.locomotives[i].movementType;
            }
        }
    }
}

export default Train;
